import React from 'react';
import { Card, CardContent, Skeleton, Box, Typography } from '@mui/material';
import { useLanguage } from '../../../../context/LanguageContext';

const StoreSelectorSkeleton = () => {
    const { t } = useLanguage();

    return (
        <Card sx={{ 
            borderRadius: 1, 
            boxShadow: 'none', 
            border: '1px solid #e0e0e0',
            mb: 2
        }}>
            <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
                <Typography variant="subtitle2" sx={{ mb: 2, color: '#6c757d', fontWeight: 500, textTransform: 'uppercase', fontSize: '0.875rem' }}>
                    {t('pages.store.selectStore')}
                </Typography>
                <Box sx={{ 
                    display: 'flex', 
                    gap: 1.5, 
                    alignItems: 'center',
                    flexWrap: { xs: 'wrap', md: 'nowrap' },
                    maxWidth: { md: '65%' }
                }}>
                    <Box sx={{ flex: { xs: '1 1 100%', md: '2' } }}>
                        <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1 }} />
                    </Box>
                    <Box sx={{ flex: { xs: '1 1 100%', md: '1' } }}>
                        <Skeleton variant="rectangular" height={40} sx={{ borderRadius: 1 }} />
                    </Box>
                    <Skeleton variant="rectangular" height={40} width={110} sx={{ borderRadius: 1, flexShrink: 0 }} />
                    <Skeleton variant="rectangular" height={40} width={110} sx={{ borderRadius: 1, flexShrink: 0 }} />
                </Box>
            </CardContent>
        </Card>
    );
};

export default StoreSelectorSkeleton;
